// Флаги направления навигации — отдельный leaf-модуль без импортов
// (кроме vue ref), чтобы composables (useBackNavigation) не тянули @/router и
// не создавали dependency cycle: router динамически импортирует страницы,
// которые импортируют composables.
import { ref } from 'vue'

// «Приложение уже сделало первый переход внутри SPA». Cold start / refresh =
// первая навигация (from.name пуст) — флаг ещё false, скелетоны загрузки
// показываются (ждём данные с сервера). После первого переключения данные
// идут из тёплых сторов / приходят быстро — скелетон не нужен, только мелькает
// «прыжком» (useDelayedFlag гейтит показ по этому флагу).
export const appBooted = ref(false)
export function markBooted(): void {
  appBooted.value = true
}

// Путь целевой (ещё не завершённой) навигации. Мобильный таб-бар показывает
// лоадер на пункте, ведущем сюда, пока грузится страница (lazy-chunk роута).
// Ставится в beforeEach роутера, сбрасывается в afterEach/onError.
export const pendingNavigationPath = ref<string | null>(null)
export function setPendingNavigation(path: string | null): void {
  pendingNavigationPath.value = path
}

// Флаг popstate — срабатывает при «Назад»/«Вперёд» браузера или router.back().
// Используется, когда роуты на одной глубине (тогда depth-хьюристика молчит).
let isPopstateNavigation = false
if (typeof window !== 'undefined') {
  window.addEventListener('popstate', () => { isPopstateNavigation = true })
}

// Маркер, что popstate инициирован нашей кнопкой «Назад» (router.back из
// useBackNavigation), а не системным жестом/кнопкой браузера. Под капотом
// router.back тоже триггерит popstate — без флага мы бы не отличили его
// от iOS edge-swipe и не дали бы анимацию там, где юзер ожидает её.
let isInAppBackButton = false
export function markInAppBack(): void {
  isInAppBackButton = true
}

// Атомарно читает и сбрасывает оба флага — guard роутера вызывает на
// каждый переход, чтобы состояние не протекало в следующую навигацию.
export function consumeNavigationFlags(): { popstate: boolean; inAppBack: boolean } {
  const flags = { popstate: isPopstateNavigation, inAppBack: isInAppBackButton }
  isPopstateNavigation = false
  isInAppBackButton = false
  return flags
}
